import React from 'react';
import type { User } from '@axiom/validation';
import { Form } from '@axiom/ui';

import { ChatFormSchema } from '../../../schema/spark/chat-form-schema';
import { useSparkSession } from '../../hooks/useSparkSession';
import { Chat } from '../Chat/Chat';

export type ChatFormProps = {
  name: string;
  user: User;
};

export const ChatForm = ({ name, user }: ChatFormProps) => {
  const { session, submitPrompt } = useSparkSession();

  return (
    <Form
      name="CHAT_FORM"
      formRef={session.chatFormRef}
      initialValues={{ chat: null }}
      schema={ChatFormSchema}
      onSubmit={submitPrompt}
    >
      {({ fireSubmit, values }) => (
        <Chat fireSubmit={fireSubmit} name={name} user={user} values={values} />
      )}
    </Form>
  );
};
